module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/5a698caf57e6e92e8e875b3eb3121fdc.png";